import { useState } from 'react';
import cn from 'classnames';
// UI
import MillionsIcon, { IconNames } from 'ui3/MillionsIcon/MillionsIcon';

import styles from './Accordion.module.scss';

type AccordionProps = {
  title: string | React.ReactNode;
  titleClassName?: string;
  className?: string;
  openedByDefault?: boolean;
  isWhiteIcon?: boolean;
  headingLevel?: 'h2' | 'h3' | 'h4';
  /** Icon shown next to the title. Rotates 180deg when expanded. */
  icon?: IconNames;
  /** Icon pixel size. Defaults to 36; pass smaller (e.g. 24) for compact FAQs. */
  iconSize?: number;
};

const Accordion: React.FC<AccordionProps> = ({
  title,
  titleClassName,
  className,
  openedByDefault = true,
  children,
  isWhiteIcon = false,
  headingLevel: HeadingTag = 'h3',
  icon = 'chevronDown',
  iconSize = 24,
}) => {
  const [open, setOpen] = useState(openedByDefault);

  const handleAccordionToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setOpen((prev) => !prev);
  };

  return (
    <div className={cn(styles.root, className)}>
      <div>
        <HeadingTag>
          <button
            className={styles.toggleButton}
            onClick={handleAccordionToggle}
            id="accordion-header-1"
            aria-expanded={open}
            aria-controls="accordion-panel-1"
          >
            <span className={cn(styles.title, titleClassName)}>{title}</span>
            <MillionsIcon
              name={icon}
              size={iconSize}
              className={cn(styles.icon, {
                [styles.iconOpen]: open,
                [styles.iconWhite]: isWhiteIcon,
              })}
            />
          </button>
        </HeadingTag>

        {open && (
          <section
            id="accordion-panel-1"
            aria-labelledby="accordion-header-1"
            className={styles.section}
          >
            {children}
          </section>
        )}
      </div>
    </div>
  );
};

export default Accordion;
